
export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What El Paso <span className="text-teal-600">Small Businesses</span> Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Don't just take our word for it. Here's what local El Paso business owners have to say about 
            their experience working with David's Website Design.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed">
              "David's team created exactly what our restaurant needed. Our website looks professional, 
              loads fast on phones, and we've seen a 40% increase in online orders since launching. 
              Best investment we've made for our business."
            </p>
            <div className="flex items-center">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                <span className="font-semibold text-teal-600">MR</span>
              </div>
              <div>
                <div className="font-semibold text-gray-900">Maria Rodriguez</div>
                <div className="text-sm text-gray-600">Owner, Casa Maria Restaurant</div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed">
              "I tried building my own website for months and got nowhere. David's team had our plumbing 
              company website done in two weeks, and it brings in 3-4 new customers every week. 
              Worth every penny."
            </p>
            <div className="flex items-center">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                <span className="font-semibold text-teal-600">JS</span>
              </div>
              <div>
                <div className="font-semibold text-gray-900">James Smith</div>
                <div className="text-sm text-gray-600">Owner, El Paso Plumbing Pro</div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex items-center mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed">
              "Professional service from start to finish. They understood our vision for our boutique 
              and created a website that perfectly represents our brand. Our online sales have tripled 
              since the launch."
            </p>
            <div className="flex items-center">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                <span className="font-semibold text-teal-600">LG</span>
              </div>
              <div>
                <div className="font-semibold text-gray-900">Lisa Garcia</div>
                <div className="text-sm text-gray-600">Owner, Elegance Boutique</div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl p-12 text-white">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">Join 200+ Successful El Paso Businesses</h3>
              <p className="text-xl mb-8 leading-relaxed opacity-90">
                We've helped over 200 small businesses in El Paso establish their online presence and grow 
                their customer base. Your business could be next.
              </p>
              <div className="grid grid-cols-2 gap-8">
                <div className="text-center">
                  <div className="text-4xl font-bold mb-2">200+</div>
                  <div className="text-sm opacity-80">Websites Launched</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold mb-2">98%</div>
                  <div className="text-sm opacity-80">Client Satisfaction</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold mb-2">85%</div>
                  <div className="text-sm opacity-80">Revenue Increase</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold mb-2">5+</div>
                  <div className="text-sm opacity-80">Years Experience</div>
                </div>
              </div>
            </div>
            
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/88a7748def23d15344f83ad6e48fc1d4.jpg"
                alt="Successful El Paso small business owners celebrating growth"
                className="w-full h-64 object-cover rounded-xl shadow-lg opacity-90"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
